import { Component, ElementRef, Input, OnChanges } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';

import { DockingBarService, PageTitleService } from '@amfam/ui-kit';

declare global {
  let iFrameResize: any;
}
@Component({
  selector: 'ds-claims-wrapper',
  templateUrl: './claims-wrapper.component.html',
  styleUrls: ['./claims-wrapper.component.scss'],
  standalone: false
})
export class ClaimsWrapperComponent implements OnChanges {
  @Input() loading: string;
  @Input() claimUrl: string;
  urlSafe;

  constructor(
    public sanitizer: DomSanitizer,
    public el: ElementRef,
    private pageTitle: PageTitleService,
    private dockingBarService: DockingBarService
  ) {}

  ngOnChanges(changes): void {
    this.pageTitle.set('Claims');
    this.dockingBarService.registerHeading('Claims');

    if (this.claimUrl && changes?.claimUrl?.currentValue) {
      this.urlSafe = this.sanitizer.bypassSecurityTrustResourceUrl(changes.claimUrl.currentValue);
    }
  }
}
